<div class="grid">
  <div class="card-md">
    <motif-card>
      <motif-card-header border="none" variant="alt">
        <img class="logo" src="./assets/images/ey-logo-inverted.svg" alt="EY Logo"/>
      </motif-card-header>
      <motif-card-body>
        <h2>Welcome to EY MS Control Tower Experience</h2>
        <h4
          class="text-gray-300 mv-20 text-normal">
          {{ loginInProgress ? 'Logging in, please wait...' : 'You have been logged out.' }}
        </h4>
        <button class="action-btn mt-3" motifButton color="primary"
                size="large" (click)="login()">
          <span class="action-btn-loader" *ngIf="loginInProgress"></span>
          <span>Login</span>
        </button>
      </motif-card-body>
    </motif-card>
  </div>
</div>
